import { render } from "./StampDutyFormulaModal.vue?vue&type=template&id=68f9a682&scoped=true"
import script from "./StampDutyFormulaModal.vue?vue&type=script&lang=js"
export * from "./StampDutyFormulaModal.vue?vue&type=script&lang=js"

import "./StampDutyFormulaModal.vue?vue&type=style&index=0&id=68f9a682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f9a682"]])

export default __exports__